import { render, staticRenderFns } from "./MetaInfo.vue?vue&type=template&id=3c64d218&scoped=true&"
import script from "./MetaInfo.vue?vue&type=script&lang=js&"
export * from "./MetaInfo.vue?vue&type=script&lang=js&"
import style0 from "./MetaInfo.vue?vue&type=style&index=0&id=3c64d218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c64d218",
  null
  
)

component.options.__file = "MetaInfo.vue"
export default component.exports